<template>
    <x-dialog custom-class="x-file-preview" :visible="visible" :config="getDialogConfig(config)"
        @close="$emit('close')"
        @update:visible="(visible)=> $emit('update:visible', visible)"
    >
        <div class="x-preview-dialog">
            <iframe :key="getCurrentPreviewUrl(uri, fileName)" ref="frame" @load="frameLoadedHandler" class="content" style="opacity: 0.1; display: block;" :src="getCurrentPreviewUrl(uri, fileName)"></iframe>
        </div>
    </x-dialog>
</template>
<script setup>
import { getCurrentInstance, ref } from 'vue';
import XDialog from '../../dialog/XDialog.vue';
import { Base64 } from 'js-base64';

const inst = getCurrentInstance();

const props = defineProps({
    visible: { default: true },
    uri: { default: null },
    fileName: { default: null },
    config: { default: {} },
})

defineEmits({
    'close': null,
    'update:visible': null,
})

const getFileUrlType = (fn)=> {
    const ext = fn.replace(/.*\./, '');
    switch (ext) {
        case 'png':
        case 'jpeg':
        case 'jpg':
        case 'bmp':
        case 'mp4':
        case 'mp3':
        case 'flv':
            return window.location.origin;
        default:
            return 'http://127.0.0.1:5900'
    }
}

const getCurrentPreviewUrl = (uri, fileName)=> {
    const url = getFileUrlType(fileName) + '/dev-api/tat/tatResource/download/' + Base64.encode(uri) + '?fullfilename=' + fileName;
    const previewUrl = window.location.origin + '/file-preview/onlinePreview?url=' + encodeURIComponent(Base64.encode(url));
    return previewUrl;
}

const getDialogConfig = (config)=> {
    if (!config) return null;
    if (!config.width) config.width = 1200;
    config.withDefaultButtons = false;
    config.title = '预览';
    config.fullscreen = true;
    return config;
}

const keydownHandler = (event)=> {
    console.log(event);
}

const frame = ref(null);
const updateFrameContentStyle = (frame)=> {
    const dom = frame.contentDocument;
    console.log(dom);
    // return;
    const container = dom.querySelector('.container');
    if (container) {
        Object.assign(container.style, {margin:0, padding:0});
        const panel = container.querySelector('.panel');
        if (panel) {
            Object.assign(panel.style, {margin:0, padding:0, border:0});
            const header = panel.querySelector('.panel-heading');
            if (header) {
                Object.assign(header.style, {display: 'none'});
            }
            const content = panel.querySelector('.divContent');
            if (content) {
                Object.assign(content.style, {background:'none', color:'inherit'})
            }
        }
    }
    const viewerContainer = dom.querySelector('.viewer-container');
    if (viewerContainer) {
        const footer = viewerContainer.querySelector('.viewer-footer');
        if (footer) {
            Object.assign(footer.style, {display: 'none'});
        }
    }
    frame.style.height = Math.max(dom.body.scrollHeight, 600) + 'px';
    frame.style.opacity = 1;

    const buttons = dom.querySelector('#button-area');
    if (buttons) {
        buttons.style.display = 'none';
    }
}
const frameLoadedHandler = ()=> {
    if (!frame.value) return;
    updateFrameContentStyle(frame.value);
    const win = frame.value.contentWindow;
    win.onkeydown = (e)=> {
        console.log(e);
        if (e.keyCode == 27) inst.emit('close');
        win.onkeydown = null;
        return;
    }
}
</script>
<style scoped>
.x-preview-dialog >>> iframe {
    border: 0;
    width: 100%;
    box-sizing: border-box;
    min-height: 800px;
    /* min-height: 800px; */
}
</style>
<style>
.x-file-preview {
    background: #00000099;
}
.x-file-preview .el-dialog__title {
    color: #FFF;
}
</style>